import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';
import { firebaseConfig } from '../constants/firebaseConfig';

/**
 * Lazily initialise Firebase and return the Auth / Firestore instances.
 *
 * Used only from extension UI surfaces (popup / side panel / settings /
 * fullscreen). Analytics is intentionally NOT initialised: it adds network
 * calls that fight the MV3 CSP and is not needed.
 */
let cachedApp: ReturnType<typeof initializeApp> | null = null;
let cachedAuth: Auth | null = null;
let cachedDb: Firestore | null = null;

function getApp_() {
  if (cachedApp) return cachedApp;
  cachedApp = getApps().length ? getApp() : initializeApp(firebaseConfig);
  return cachedApp;
}

export function getFirebaseAuth(): Auth {
  if (cachedAuth) return cachedAuth;
  cachedAuth = getAuth(getApp_());
  return cachedAuth;
}

export function getFirestoreDb(): Firestore {
  if (cachedDb) return cachedDb;
  cachedDb = getFirestore(getApp_());
  return cachedDb;
}
